"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJwt = void 0;
var b64DecodeUnicode = function (str) {
    return decodeURIComponent(Array.prototype.map
        .call(atob(str), function (c) { return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2); })
        .join(""));
};
var parseJwt = function (token) {
    return JSON.parse(b64DecodeUnicode(token.split(".")[1].replace("-", "+").replace("_", "/")));
};
exports.parseJwt = parseJwt;
exports.default = exports.parseJwt;
